import React, { useContext } from 'react';
import WouldYouRecommendCollection from '../steps/WouldYouRecommendCollection';
import ReviewOnGoogleOrSolv from '../steps/ReviewOnGoogleOrSolv';
import ThankYou from '../steps/ThankYou';
import ReviewOnSolvCollectorWithGoogleFooter from '../steps/ReviewOnSolvCollectorWithGoogleFooter';
import { ADD_REVIEW_UNGATED_REVIEW_ON_GOOGLE_OR_SOLV } from '../../../constants/index';
import { ReviewContext } from '~/routes/addReview/context';

const UngatedReviewOnGoogleOrSolv = () => {
  const context = useContext(ReviewContext)!;

  const {
    booking,
    bookingId,
    error,
    flowState,
    googleUrl,
    handleRatingChange,
    handleHasRecommendedClinicChange,
    hasRecommendedClinic,
    isSubmitting,
    leaveAReview,
    location,
    onStarChange,
    review,
    setFlowState,
    starRating,
    submitReview,
  } = context;

  return (
    <>
      <WouldYouRecommendCollection
        booking={booking}
        bookingId={bookingId}
        error={error}
        flowState={flowState}
        handleHasRecommendedClinicChange={handleHasRecommendedClinicChange}
        handleRatingChange={handleRatingChange}
        location={location}
        onStarChange={onStarChange}
        review={review}
        setFlowState={setFlowState}
        starRating={starRating}
        submitReview={submitReview}
      />

      <ReviewOnGoogleOrSolv
        booking={booking}
        bookingId={bookingId}
        error={error}
        flowState={flowState}
        googleUrl={googleUrl}
        handleRatingChange={handleRatingChange}
        hasRecommendedClinic={hasRecommendedClinic}
        isSubmitting={isSubmitting}
        leaveAReview={leaveAReview}
        location={location}
        review={review}
        setFlowState={setFlowState}
        starRating={starRating}
        submitReview={submitReview}
      />

      <ReviewOnSolvCollectorWithGoogleFooter
        booking={booking}
        bookingId={bookingId}
        error={error}
        flowState={flowState}
        flowType={ADD_REVIEW_UNGATED_REVIEW_ON_GOOGLE_OR_SOLV}
        googleUrl={googleUrl}
        handleRatingChange={handleRatingChange}
        leaveAReview={leaveAReview}
        location={location}
        onStarChange={onStarChange}
        ratingDate={booking?.ratingDate}
        review={review}
        starRating={starRating}
        submitReview={submitReview}
      />

      <ThankYou
        booking={booking}
        bookingId={bookingId}
        flowState={flowState}
        starRating={starRating}
      />
    </>
  );
};

export default UngatedReviewOnGoogleOrSolv;
